import { api } from '@/lib/api'

/** @typedef {import('@/types/api').Blockout} Blockout */

/**
 * @param {{ from: string, to: string }} range
 * @returns {Promise<Blockout[]>}
 */
export async function fetchBlockouts(range) {
  const { data } = await api.get('/blockouts', { params: range })
  return data.data.blockouts
}

/**
 * @param {Record<string, unknown>} payload
 * @returns {Promise<Blockout>}
 */
export async function createBlockout(payload) {
  const { data } = await api.post('/blockouts', payload)
  return data.data.blockout
}

/**
 * @param {number} blockoutId
 * @param {Record<string, unknown>} payload
 * @returns {Promise<Blockout>}
 */
export async function updateBlockout(blockoutId, payload) {
  const { data } = await api.put(`/blockouts/${blockoutId}`, payload)
  return data.data.blockout
}

/**
 * @param {number} blockoutId
 * @returns {Promise<void>}
 */
export async function deleteBlockout(blockoutId) {
  await api.delete(`/blockouts/${blockoutId}`)
}
